<template>
  <van-popup v-model="showPop" position="bottom" @close="colsePop">
    <div class="popup_div">
      <div>
        <dl class="popup_dl">
          <dt>
            <img class="popup_img" :src="thumb" alt>
          </dt>
          <dd>
            <p>￥{{ strategy_price }}</p>
          </dd>
        </dl>
      </div>
      <div class="lessons">
        <div>
          <p class="p_title">请选择购买课程</p>
        </div>
        <div class="p_span">
          <span v-for="(item, index) in strategyArr" :key="index" :class="{ span1: index === selectIdx }" @click="addStrategyStr(index,item.id)">{{ item.strategy_name }}</span>
        </div>
      </div>
      <div class="popup_btn" @click="goBay()">
        确定
      </div>
    </div>
  </van-popup>
</template>

<script>
import cookies from 'js-cookie'
import { getLesson, getStategyById } from '@/api/exam'

export default {
  props: ['popStrategy'],
  data () {
    return {
      lesson_id: cookies.get('lesson_id') ? cookies.get('lesson_id') : 0,
      isBuy: false,
      strategyArr: [],
      thumb: '',
      showPop: false,
      strategy_price: '',
      strategyList: [],
      selectIdx: 0,
      selectIds: ''
    }
  },
  watch: {
    popStrategy (newV) {
      this.showPop = newV
    }
  },
  created () {
    this.getTheLessonInfo()
  },
  methods: {
    // 获取课程信息
    getTheLessonInfo () {
      var info = {
        lesson_id: this.lesson_id
      }
      getLesson(info).then((res) => {
        if (res.errNo === 0) {
          const data = res.result
          const lesson = data.lesson_info
          this.thumb = lesson.thumb
          this.isBuy = data.is_buy
          const strategy = data.strategy ? data.strategy : []
          this.strategyArr = strategy
          if (this.strategyArr.length > 0 && !this.isBuy) {
            // 显示销售策略
            // console.log('有 策略');
            this.$emit('setShowStrategy', true)
            // 请求销售策略数据
            this.selectIds = this.strategyArr[0].id
            this.getStategyListById(this.selectIds)
          }
          else {
            // console.log('无 策略');
            this.$emit('setShowStrategy', false)
          }
        }
      })
    },
    // 请求销售策略数据
    getStategyListById (id) {
      const p = {
        id: id
      }
      getStategyById(p).then(res => {
        if (res.errNo === 0) {
          const result = res.result
          this.strategy_price = result.strategy_price
          const list = result.list ? result.list : []
          this.strategyList = list
        }
      })
    },
    // 取消弹框
    colsePop () {
      this.$emit('colseStrategy')
    },
    // 选择策略
    addStrategyStr (index, id) {
      this.selectIds = id
      this.selectIdx = index
      this.getStategyListById(id)
    },
    goBay () {
      this.$emit('buyStategy', 7, this.selectIds)
    }
  }
}
</script>
<style lang="scss" scoped>
.test {
  width: 100%;
  height: 200px;
  background-color: aqua;
}
.popup_div {
  width: 100%;
  height: 100%;
  position: relative;
}
.popup_dl {
  display: flex;
  p {
    padding: 150px 0 0 20px;
    font-weight: 600;
    font-size: 40px;
    color: #ee2e2e;
  }
}
.popup_img {
  width: 240px;
  height: 179px;
  margin: 32px 0 0 26px;
  object-fit: cover;
  overflow: hidden;
}
.p_title {
  font-weight: 600;
  font-size: 30px;
  padding: 5px 0 0 25px;
}
.lessons {
  padding: 10px 0 100px 0;
}
.p_span {
  min-height: 200px;
  overflow: auto;
  padding-bottom: 20px;
  .span1 {
    display: inline-block;
    border: 2px solid #ee2e2e;
    background: #f9edeb;
    padding: 5px 15px;
    border-radius: 25px;
    margin: 20px 0 10px 23px;
    color: #ee2e2e;
  }
  span {
    display: inline-block;
    border: 2px solid #f4f4f4;
    background: #f4f4f4;
    padding: 7px 15px;
    border-radius: 25px;
    margin: 20px 0 10px 23px;
    color: #111;
  }
}
.popup_btn {
  width: 100%;
  height: 125px;
  background: #ee2e2e;
  line-height: 125px;
  color: #fff;
  text-align: center;
  font-size: 35px;
  position: absolute;
  bottom: 0;
}
.popup_btn_gray {
  width: 100%;
  height: 125px;
  background: #e5e5e5;
  line-height: 125px;
  color: #fff;
  text-align: center;
  font-size: 35px;
  // position: absolute;
  // bottom: 0;
}
</style>
